// date formatting service

import moment from 'moment'
import events from '../events'

const DATETIME_API_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm:ss'

export default {
  longFormat (datetime) {
    return this.updateInstanceLocale(datetime).format('lll')
  },
  dateFormat (datetime) {
    // Sep 4, 2018
    return this.updateInstanceLocale(datetime).format('ll')
  },
  timeFormat (datetime) {
    // 11:45 AM
    return this.updateInstanceLocale(datetime).format('LT')
  },
  tzFormat (datetime) {
    return this.updateInstanceLocale(datetime).format('z')
  },
  parseDate (timestamp) {
    return moment.utc(timestamp).local()
  },
  toApiFormat (datetime) {
    return datetime.utc().format(DATETIME_API_INPUT_FORMAT)
  },
  fromNow (timestamp) {
    return this.parseDate(timestamp).fromNow(true)
  },
  now () {
    return moment()
  },
  updateInstanceLocale (m) {
    // update the object's locale to the global moment locale
    return m.locale(moment.locale())
  },
  updateLocale (l) {
    // update the global moment locale
    moment.locale(l)
    events.bus.$emit('locale-changed', l)
  },
  bus: events.bus
}



// WEBPACK FOOTER //
// ./src/services/dates/index.js